import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { useTranslationApp } from "../../lib/i18next";
import { TIKTOK_CREDIT_BADGE_TOOLTIP } from "../../i18n/keysTranslations";
import {
  GRADIENT_TIKTOK_CREDIT,
  GRADIENT_TIKTOK_CREDIT_COLOR_TEXT,
  TIKTOK_CYAN,
  TIKTOK_PINK,
} from "../../utils/colors";
import { TIKTOK_CREDIT_PERCENTAGE } from "../../utils/constants";

const TikTokCreditBadge = ({ nameBusiness, sx = {} }) => {
  const { t } = useTranslationApp();

  return (
    <Tooltip
      title={t(TIKTOK_CREDIT_BADGE_TOOLTIP, { NAME_BUSINESS: nameBusiness })}
      arrow
    >
      <Box
        component="span"
        data-testid="tiktok-credit-badge"
        aria-label={t(TIKTOK_CREDIT_BADGE_TOOLTIP, {
          NAME_BUSINESS: nameBusiness,
        })}
        onMouseDown={(event) => event.stopPropagation()}
        sx={{
          flexShrink: 0,
          display: "inline-flex",
          alignItems: "center",
          height: 24,
          px: 1,
          borderRadius: 999,
          background: GRADIENT_TIKTOK_CREDIT,
          color: GRADIENT_TIKTOK_CREDIT_COLOR_TEXT,
          fontSize: "0.8rem",
          fontWeight: 900,
          letterSpacing: "-0.2px",
          lineHeight: 1,
          textShadow: `-1px -1px 0 ${TIKTOK_CYAN}, 1px 1px 0 ${TIKTOK_PINK}`,
          boxShadow:
            "0 2px 6px rgba(10, 10, 10, 0.25), inset 0 0 0 1px rgba(255, 255, 255, 0.12)",
          cursor: "default",
          ...sx,
        }}
      >
        {TIKTOK_CREDIT_PERCENTAGE}
      </Box>
    </Tooltip>
  );
};

export default TikTokCreditBadge;
